/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import UploadImage from "../upload";

const ImageDialogUploadPanel = () => {
    
    return (
        <div className="simplicity-image-selector-window-content-gallery">
            <div className='simplicity-upload-drop-container'>
                <UploadImage />
            </div>
        </div>
    );
};

export { ImageDialogUploadPanel };
